// Tab order is the wireframe's, with Metrics added sixth (Loom 2026-09-20, Sam 0:39).
// Shared by the route config and the shell so a tab cannot exist in one and not the other.
export const VOICE_STUDIO_TABS = [
  { key: 'explore', label: 'Explore' },
  { key: 'voices', label: 'Voices' },
  { key: 'clone', label: 'Clone' },
  { key: 'design', label: 'Design' },
  { key: 'lexicons', label: 'Lexicons' },
  { key: 'metrics', label: 'Metrics' },
] as const

export type VoiceStudioTabKey = (typeof VOICE_STUDIO_TABS)[number]['key']

export const DEFAULT_VOICE_STUDIO_TAB: VoiceStudioTabKey = 'explore'

export const resolveVoiceStudioTab = (pathname: string): VoiceStudioTabKey => {
  const last = pathname.split('/').filter(Boolean).pop()
  const match = VOICE_STUDIO_TABS.find((tab) => tab.key === last)
  return match ? match.key : DEFAULT_VOICE_STUDIO_TAB
}
